const STORAGE_KEYS = {
      selected_language: "selected_language",
      auth_details: "auth_details"
    };
    
    export default STORAGE_KEYS;